// extracted by mini-css-extract-plugin
module.exports = {"container":"e_T5","icon":"e_U5"};